<template>
    <div>
        <AppHeader />
        
        <main class="dip-page">
            <div class="container">
                <div class="dip-container">
                    <!-- Título -->
                    <div class="dip-header-main">
                        <h1>{{ $t('dip.title') }}</h1>
                        <p class="dip-subtitle">{{ $t('dip.subtitle') }}</p>
                    </div>

                    <!-- Entidad aseguradora -->
                    <div class="dip-entity-box">
                        <div class="dip-entity-row">
                            <span class="dip-entity-label">{{ $t('dip.entity') }}:</span>
                            <span class="dip-entity-value">ASISA, Asistencia Sanitaria Interprovincial de Seguros, S.A.U. España. DGSEP: C-0461</span>
                        </div>
                        <div class="dip-entity-row">
                            <span class="dip-entity-label">{{ $t('dip.product') }}:</span>
                            <span class="dip-entity-value">{{ $t('dip.product_name') }}</span>
                        </div>
                    </div>
                    
                    <div class="dip-content">
                        <!-- ¿En qué consiste? -->
                        <div class="dip-panel">
                            <div class="dip-panel-header">
                                <h2>{{ $t('dip.what_is') }}</h2>
                            </div>
                            <div class="dip-panel-body">
                                <p class="text-justify">{{ $t('dip.what_is_text') }}</p>
                                <p class="text-justify">{{ $t('dip.what_is_optional_intro') }}</p>
                                <ul class="dip-list">
                                    <li>{{ $t('dip.optional1') }}</li>
                                    <li>{{ $t('dip.optional2') }}</li>
                                    <li>{{ $t('dip.optional3') }}</li>
                                </ul>
                            </div>
                        </div>

                        <!-- ¿Qué se asegura? -->
                        <div class="dip-panel">
                            <div class="dip-panel-header">
                                <h2>{{ $t('dip.what_is_covered') }}</h2>
                            </div>
                            <div class="dip-panel-body">
                                <h3>{{ $t('dip.mandatory_coverage') }}</h3>
                                <ul class="dip-list">
                                    <li v-for="item in mandatoryCoverage" :key="item">✅ {{ item }}</li>
                                </ul>

                                <h3>{{ $t('dip.optional_coverage') }}</h3>
                                <ul class="dip-list">
                                    <li v-for="item in optionalCoverage" :key="item">✅ {{ item }}</li>
                                </ul>
                            </div>
                        </div>

                        <!-- ¿Qué no está asegurado? -->
                        <div class="dip-panel dip-panel-warning">
                            <div class="dip-panel-header">
                                <h2>{{ $t('dip.what_is_not_covered') }}</h2>
                            </div>
                            <div class="dip-panel-body">
                                <ul class="dip-list">
                                    <li v-for="item in exclusions" :key="item">❌ {{ item }}</li>
                                </ul>
                            </div>
                        </div>

                        <!-- ¿Dónde estoy cubierto? -->
                        <div class="dip-panel">
                            <div class="dip-panel-header">
                                <h2>{{ $t('dip.where_covered') }}</h2>
                            </div>
                            <div class="dip-panel-body">
                                <p class="text-justify">✅ {{ $t('dip.where_covered_text') }}</p>
                            </div>
                        </div>

                        <!-- Obligaciones -->
                        <div class="dip-panel">
                            <div class="dip-panel-header">
                                <h2>{{ $t('dip.obligations') }}</h2>
                            </div>
                            <div class="dip-panel-body">
                                <ul class="dip-list">
                                    <li v-for="item in obligations" :key="item">• {{ item }}</li>
                                </ul>
                            </div>
                        </div>

                        <!-- Pagos -->
                        <div class="dip-panel">
                            <div class="dip-panel-header">
                                <h2>{{ $t('dip.payments') }}</h2>
                            </div>
                            <div class="dip-panel-body">
                                <ul class="dip-list">
                                    <li v-for="item in payments" :key="item">• {{ item }}</li>
                                </ul>
                            </div>
                        </div>

                        <!-- Inicio y fin -->
                        <div class="dip-panel">
                            <div class="dip-panel-header">
                                <h2>{{ $t('dip.coverage_start_end') }}</h2>
                            </div>
                            <div class="dip-panel-body">
                                <ul class="dip-list">
                                    <li v-for="item in coverageStartEnd" :key="item">• {{ item }}</li>
                                </ul>
                            </div>
                        </div>

                        <!-- Finalizar -->
                        <div class="dip-panel">
                            <div class="dip-panel-header">
                                <h2>{{ $t('dip.how_end') }}</h2>
                            </div>
                            <div class="dip-panel-body">
                                <p class="text-justify">{{ $t('dip.how_end_text') }}</p>
                            </div>
                        </div>

                        <!-- Footer del DIP -->
                        <div class="dip-footer-note">
                            <p><em>{{ $t('dip.coverage_details_excluded') }}</em></p>
                            <p><em>{{ $t('dip.coverage_details_included') }}</em></p>
                        </div>
                    </div>

                    <!-- Botones -->
                    <div class="dip-actions" style="display: none;">
                        <button @click="descargarPDF" class="btn btn-outline">
                            <ion-icon name="download-outline"></ion-icon> {{ $t('dip.download') }}
                        </button>
                        <button @click="continuar" class="btn btn-primary" v-if="!hideDiv">
                            {{ $t('dip.continue') }} <ion-icon name="arrow-forward-outline"></ion-icon>
                        </button>
                    </div>
                </div>
            </div>
        </main>

        <AppFooter />
        <WhatsAppFloat />
    </div>
</template>

<script>
import AppHeader from '@/components/layout/Header.vue'
import AppFooter from '@/components/layout/Footer.vue'
import WhatsAppFloat from '@/components/common/WhatsAppFloat.vue'
import { jsPDF } from 'jspdf'

export default {
    name: 'FichaProducto',
    components: {
        AppHeader,
        AppFooter,
        WhatsAppFloat
    },
    data(){
        return{
            hideDiv: false
        }
    },
    mounted() {
        // ✅ Verificar si viene de success.html con pago completado
        const urlParams = new URLSearchParams(window.location.search)
        const info = urlParams.get('info')
        
        if (info === 'true') {
            this.hideDiv = true
        }
    },
    computed: {
        currentLang() {
            return this.$route.params.lang || 'es'
        },
        mandatoryCoverage() {
            return [
                this.$t('dip.coverage1'),
                this.$t('dip.coverage2'),
                this.$t('dip.coverage3'),
                this.$t('dip.coverage4'),
                this.$t('dip.coverage5'),
                this.$t('dip.coverage6'),
                this.$t('dip.coverage7'),
                this.$t('dip.coverage8'),
                this.$t('dip.coverage9')
            ]
        },
        optionalCoverage() {
            return [
                this.$t('dip.opt_coverage1'),
                this.$t('dip.opt_coverage2'),
                this.$t('dip.opt_coverage3')
            ]
        },
        exclusions() {
            return [
                this.$t('dip.exclusion1'),
                this.$t('dip.exclusion2'),
                this.$t('dip.exclusion3'),
                this.$t('dip.exclusion4'),
                this.$t('dip.exclusion5'),
                this.$t('dip.exclusion6')
            ]
        },
        obligations() {
            return [
                this.$t('dip.obligation1'),
                this.$t('dip.obligation2'),
                this.$t('dip.obligation3'),
                this.$t('dip.obligation4'),
                this.$t('dip.obligation5'),
                this.$t('dip.obligation6'),
                this.$t('dip.obligation7'),
                this.$t('dip.obligation8')
            ]
        },
        payments() {
            return [
                this.$t('dip.payment1'),
                this.$t('dip.payment2'),
                this.$t('dip.payment3')
            ]
        },
        coverageStartEnd() {
            return [
                this.$t('dip.coverage_start_end1'),
                this.$t('dip.coverage_start_end2')
            ]
        }
    },
    methods: {
        descargarPDF() {
            const doc = new jsPDF({
                    orientation: 'portrait',
                    unit: 'mm',
                    format: 'a4',
                    compress: true
                })
            const fullDate = new Date().toLocaleDateString('es-ES')

                // ✅ Función para limpiar texto de caracteres extraños
            const limpiarTexto = (texto) => {
                if (!texto) return ''
                // Eliminar caracteres no deseados
                let limpio = texto
                    .replace(/\s+/g, ' ')  // Múltiples espacios a uno solo
                    .replace(/[\u200B-\u200D\uFEFF]/g, '')  // Eliminar caracteres de ancho cero
                    .trim()
                return limpio
            }
            
            // Título
            doc.setFontSize(18)
            doc.setFont('helvetica', 'bold')
            doc.text('ASISA HEALTH RESIDENTS', 105, 20, { align: 'center' })
            
            doc.setFontSize(11)
            doc.setFont('helvetica', 'normal')
            doc.text('Documento de información sobre el producto de seguro', 105, 30, { align: 'center' })
            
            // Entidad
            doc.setFontSize(9)
            doc.text('Entidad aseguradora: ASISA, Asistencia Sanitaria Interprovincial de Seguros, S.A.U. España. DGSEP: C-0461', 15, 42)
            doc.text('Producto: ASISA HEALTH RESIDENTS', 15, 48)
            
            let y = 58
            const lineHeight = 6
            const maxWidth = 175  // ← Reducido de 180 a 175 para dar margen

            // ✅ Función para agregar texto con limpieza
            // Función para agregar texto con ajuste de línea
            const addText = (text, indent = 0, fontSize = 9, isBold = false) => {
                if (y > 270) { doc.addPage(); y = 20 }
                doc.setFontSize(fontSize)
                doc.setFont('helvetica', isBold ? 'bold' : 'normal')
                const lines = doc.splitTextToSize(text, maxWidth - indent)
                doc.text(lines, 15 + indent, y)
                y += lines.length * lineHeight + 2
            }
            
            // Función para agregar lista
            const addList = (items, indent = 5) => {
                items.forEach(item => {
                    if (y > 270) { doc.addPage(); y = 20 }
                    doc.setFontSize(9)
                    doc.setFont('helvetica', 'normal')
                    const lines = doc.splitTextToSize(item, maxWidth - indent - 5)
                    doc.text(lines, 15 + indent, y)
                    y += lines.length * lineHeight + 1
                })
                y += 3
            }
            
            // Función para agregar sección con título
            const addSection = (title, content, isList = false, items = []) => {
                if (y > 270) { doc.addPage(); y = 20 }
                doc.setFontSize(12)
                doc.setFont('helvetica', 'bold')
                doc.text(title, 15, y)
                y += 8
                
                if (isList) {
                    addList(items)
                } else {
                    if (y > 270) { doc.addPage(); y = 20 }
                    doc.setFontSize(9)
                    doc.setFont('helvetica', 'normal')
                    const lines = doc.splitTextToSize(content, maxWidth)
                    doc.text(lines, 15, y)
                    y += lines.length * lineHeight + 3
                }
                y += 2
            }
            
            // ============================================
            // 1. ¿En qué consiste?
            // ============================================
            addSection('¿En qué consiste este tipo de seguro?', this.$t('dip.what_is_text'))
            
            addSection('', this.$t('dip.what_is_optional_intro'))
            addList([
                '• ' + this.$t('dip.optional1'),
                '• ' + this.$t('dip.optional2'),
                '• ' + this.$t('dip.optional3')
            ])
            
            // ============================================
            // 2. ¿Qué se asegura?
            // ============================================
            if (y > 270) { doc.addPage(); y = 20 }
            doc.setFontSize(12)
            doc.setFont('helvetica', 'bold')
            doc.text('¿Qué se asegura?', 15, y)
            y += 8
            
            doc.setFontSize(10)
            doc.setFont('helvetica', 'bold')
            doc.text('Garantía Obligatoria de Asistencia Sanitaria:', 15, y)
            y += 6
            
            addList(this.mandatoryCoverage)
            
            if (y > 270) { doc.addPage(); y = 20 }
            doc.setFontSize(10)
            doc.setFont('helvetica', 'bold')
            doc.text('Garantías Opcionales:', 15, y)
            y += 6
            
            addList(this.optionalCoverage)
            
            // ============================================
            // 3. ¿Qué no está asegurado?
            // ============================================
            if (y > 270) { doc.addPage(); y = 20 }
            doc.setFontSize(12)
            doc.setFont('helvetica', 'bold')
            doc.text('¿Qué no está asegurado?', 15, y)
            y += 8
            
            addList(this.exclusions)
            
            // ============================================
            // 4. ¿Dónde estoy cubierto?
            // ============================================
            if (y > 270) { doc.addPage(); y = 20 }
            doc.setFontSize(12)
            doc.setFont('helvetica', 'bold')
            doc.text('¿Dónde estoy cubierto?', 15, y)
            y += 8
            
            addText(this.$t('dip.where_covered_text'))
            
            // ============================================
            // 5. Obligaciones
            // ============================================
            if (y > 270) { doc.addPage(); y = 20 }
            doc.setFontSize(12)
            doc.setFont('helvetica', 'bold')
            doc.text('¿Cuáles son mis obligaciones?', 15, y)
            y += 8
            
            addList(this.obligations)
            
            // ============================================
            // 6. Pagos
            // ============================================
            if (y > 270) { doc.addPage(); y = 20 }
            doc.setFontSize(12)
            doc.setFont('helvetica', 'bold')
            doc.text('¿Cuándo y cómo tengo que efectuar los pagos?', 15, y)
            y += 8
            
            addList(this.payments)
            
            // ============================================
            // 7. Inicio y fin de cobertura
            // ============================================
            if (y > 270) { doc.addPage(); y = 20 }
            doc.setFontSize(12)
            doc.setFont('helvetica', 'bold')
            doc.text('¿Cuándo comienza y finaliza la cobertura?', 15, y)
            y += 8
            
            addList(this.coverageStartEnd)
            
            // ============================================
            // 8. Finalizar contrato
            // ============================================
            if (y > 270) { doc.addPage(); y = 20 }
            doc.setFontSize(12)
            doc.setFont('helvetica', 'bold')
            doc.text('¿Cómo puedo finalizar el contrato?', 15, y)
            y += 8
            
            addText(this.$t('dip.how_end_text'))
            
            // ============================================
            // 9. Footer
            // ============================================
            if (y > 270) { doc.addPage(); y = 20 }
            doc.setFontSize(8)
            doc.setFont('helvetica', 'italic')
            const footerLines1 = doc.splitTextToSize(
                'El detalle completo de las coberturas excluidas está a disposición de los asegurados en las condiciones generales del producto.',
                maxWidth
            )
            doc.text(footerLines1, 15, y)
            y += footerLines1.length * lineHeight + 3
            
            const footerLines2 = doc.splitTextToSize(
                'El detalle completo de las coberturas incluidas está a disposición de los asegurados en las condiciones generales del producto.',
                maxWidth
            )
            doc.text(footerLines2, 15, y)
            
            // Guardar
            doc.save('Ficha_ASISA_Health_Residents.pdf')
        },
        continuar() {
            this.$router.push({ 
                name: 'aviso-legalck',
                params: { lang: this.currentLang } 
            })
        }
    }
}
</script>

<style scoped>
.dip-page {
    background: #f8fafc;
    padding: 60px 0;
    min-height: 70vh;
}

.dip-container {
    max-width: 900px;
    margin: 0 auto;
    background: white;
    padding: 50px;
    border-radius: 16px;
    box-shadow: 0 4px 15px rgba(0,0,0,0.05);
}

/* Título principal */
.dip-header-main {
    text-align: center;
    margin-bottom: 30px;
}

.dip-header-main h1 {
    color: #1C4A8D;
    font-size: 2.2rem;
    margin-bottom: 5px;
}

.dip-subtitle {
    color: #6c757d;
    font-size: 1rem;
}

/* Entidad */
.dip-entity-box {
    background: #f0f5fa;
    padding: 16px 20px;
    border-radius: 10px;
    margin-bottom: 30px;
    border-left: 4px solid #1C4A8D;
}

.dip-entity-row {
    display: flex;
    gap: 10px;
    font-size: 0.95rem;
    color: #333;
    padding: 3px 0;
}

.dip-entity-label {
    font-weight: 700;
    color: #1C4A8D;
    min-width: 150px;
}

.dip-entity-value {
    font-weight: 500;
}

/* Panel */
.dip-panel {
    background: #ffffff;
    border: 1px solid #e9ecef;
    border-radius: 12px;
    margin-bottom: 25px;
    overflow: hidden;
    box-shadow: 0 2px 4px rgba(0,0,0,0.02);
    transition: box-shadow 0.2s;
}

.dip-panel:hover {
    box-shadow: 0 4px 12px rgba(0,0,0,0.05);
}

.dip-panel-warning {
    border-left: 4px solid #F04B00;
}

.dip-panel-header {
    background: #f8f9fa;
    padding: 14px 22px;
    border-bottom: 1px solid #e9ecef;
}

.dip-panel-header h2 {
    color: #1C4A8D;
    font-size: 1.1rem;
    margin: 0;
    font-weight: 700;
}

.dip-panel-body {
    padding: 20px 22px;
}

.dip-panel-body h3 {
    color: #2d3748;
    font-size: 0.95rem;
    margin-top: 10px;
    margin-bottom: 8px;
    font-weight: 600;
}

.dip-panel-body p {
    margin-bottom: 10px;
    color: #4a5568;
    line-height: 1.7;
}

.text-justify {
    text-align: justify;
    word-spacing: normal;  /* ← Añade esto para evitar espacios extraños */
    hyphens: auto;        /* ← Permite guiones para mejor justificación */
}

/* Listas */
.dip-list {
    list-style: none;
    padding: 0;
    margin: 0;
}

.dip-list li {
    padding: 4px 0;
    color: #4a5568;
    font-size: 0.92rem;
    line-height: 1.6;
}

/* Footer nota */
.dip-footer-note {
    background: #f8f9fa;
    padding: 16px 22px;
    border-radius: 10px;
    border-left: 4px solid #F04B00;
    margin-top: 10px;
}

.dip-footer-note p {
    margin: 4px 0;
    font-size: 0.85rem;
    color: #555;
    font-style: italic;
}

/* Botones */
.dip-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 30px;
    padding-top: 20px;
    border-top: 2px solid #e9ecef;
}

.btn {
    padding: 12px 30px;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    transition: all 0.3s;
    border: none;
    font-size: 0.95rem;
}

.btn-outline {
    background: transparent;
    color: #1C4A8D;
    border: 2px solid #1C4A8D;
}

.btn-outline:hover {
    background: #1C4A8D;
    color: white;
}

.btn-primary {
    background: #1C4A8D;
    color: white;
}

.btn-primary:hover {
    background: #143A6E;
}

/* Responsive */
@media (max-width: 768px) {
    .dip-container {
        padding: 25px;
    }
    .dip-header-main h1 {
        font-size: 1.6rem;
    }
    .dip-entity-row {
        flex-direction: column;
        gap: 2px;
    }
    .dip-entity-label {
        min-width: auto;
    }
    .dip-actions {
        flex-direction: column;
        gap: 15px;
    }
    .dip-actions .btn {
        width: 100%;
        justify-content: center;
    }
}
</style>